export default [
  {
    name: 'BankingCorrespondentsCompaniesList',
    path: 'settings/companies/banking-correspondents',
    component: () => import('pages/settings/banking-correspondents/BankingCorrespondentsCompaniesList.vue')
  },
  {
    name: 'BankingCorrespondentsList',
    path: 'settings/companies/:id/banking-correspondents',
    component: () => import('pages/settings/banking-correspondents/BankingCorrespondentsList.vue')
  },
  {
    name: 'BankingCorrespondentsCreate',
    path: 'settings/companies/:id/banking-correspondents/new',
    component: () => import('pages/settings/banking-correspondents/form/BankingCorrespondentsForm.vue')
  },
  {
    name: 'BankingCorrespondentsEdit',
    path: 'settings/companies/:id/banking-correspondents/:bankingCorrespondentId/edit',
    component: () => import('pages/settings/banking-correspondents/form/BankingCorrespondentsForm.vue')
  }
]
